export default __webpack_public_path__ + "static/style3.3_Elena-b6f9d0e5f4705cd553395e1ecf8642fe.wav";